import Axios, {AxiosInstance, AxiosPromise} from 'axios';
import ApiService from './apiService';
import EcCommon from '../../../types/ec/ecCommon';

export const ClubServiceAxiosInstance: AxiosInstance = Axios.create({
	baseURL: window.lt.api.apimUrl + 'enterprise-coach/club',
	headers: {
		'Ocp-Apim-Subscription-Key': window.lt.api.apimKey,
	},
});

export default class ClubService extends ApiService implements EcCommon.IClubService {
	constructor() {
		super('club-service', ClubServiceAxiosInstance);
	}

	public getClubLocations(): AxiosPromise<EcCommon.IClubsResponse> {
		return this.axiosInstance.get('/clubs');
	}
}

export const clubService = new ClubService();
